import { render } from "./SoftSwitch.vue?vue&type=template&id=0d219dae"
import script from "./SoftSwitch.vue?vue&type=script&lang=js"
export * from "./SoftSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__